<div class="container-fluid px-4 mt-4 mb-5">
    <!-- Page Header -->
    <div class="cp-page-header mb-4">
        <div class="cp-page-title">
            <i class="fa-solid fa-shield-halved me-2"></i>
            Gestión de Guardias
        </div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/control-ingreso">Control de Ingreso</a></li>
                <li class="breadcrumb-item active">Registros</li>
            </ol>
        </nav>
    </div>

    <div class="row">
        <div class="col-xl-12 col-md-12">
            <div class="card h-100">
                <div class="card-header cp-list-header">
                    <span class="cp-list-title">Listado de Guardias</span>
                    <div class="btn-group btn-group-sm" role="group">
                        <button class="btn btn-outline-dark" (click)="openPositions()" title="Crear, editar o eliminar los cargos (etiquetas) del personal">
                            <i class="fa-solid fa-tags me-1"></i> Cargos
                        </button>
                        <button class="btn btn-outline-danger" (click)="openRrhh('terminations')" title="Eliminar en masa a los guardias desvinculados según RRHH">
                            <i class="fa-solid fa-user-minus me-1"></i> Desvincular (RRHH)
                        </button>
                        <button class="btn btn-outline-success" (click)="openRrhh('workers')" title="Agregar en masa a los guardias nuevos según RRHH">
                            <i class="fa-solid fa-user-plus me-1"></i> Agregar nuevos (RRHH)
                        </button>
                        <button class="btn btn-secondary" (click)="openModal(addFile,'sm')">
                            <i class="fa-solid fa-file-arrow-up me-1"></i> Importar
                        </button>
                        <button class="btn btn-primary" (click)="openModal(add)">
                            <i class="fa-solid fa-circle-plus me-1"></i> Nuevo
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <!-- Filter Panel -->
                    <div class="cp-filter-panel" [formGroup]="form">
                        <div class="row">
                            <div style="flex: 1 1 300px;">
                                <label class="form-label">Buscar Guardia</label>
                                <app-toolbar-search [placeholder]="'Nombre o RUT'" [hideFilter]="true" (onEmptyInput)="clean()" (onSearch)="search($event)"/>
                            </div>
                            <div style="flex: 0 1 180px;">
                                <label class="form-label">Estado</label>
                                <select class="form-select" formControlName="state_id" (change)="filterChange()">
                                    <option value="">Todos</option>
                                    <option value="1">Habilitado</option>
                                    <option value="0">No habilitado</option>
                                </select>
                            </div>
                            <div style="flex: 0 1 160px;">
                                <label class="form-label">OS10</label>
                                <select class="form-select" formControlName="os10" (change)="filterChange()">
                                    <option value="">Todos</option>
                                    <option value="1">Con OS10</option>
                                    <option value="0">Sin OS10</option>
                                </select>
                            </div>
                            <div style="flex: 0 1 180px;">
                                <label class="form-label">Cargo</label>
                                <select class="form-select" formControlName="position_id" (change)="filterChange()">
                                    <option value="">Todos</option>
                                    <option *ngFor="let p of positions" [value]="p.id">{{ p.name }}</option>
                                </select>
                            </div>
                            <div style="flex: 0 1 120px;">
                                <button class="btn btn-outline-secondary w-100" type="button" (click)="clean()">
                                    <i class="fa-solid fa-rotate-left me-1"></i> Limpiar
                                </button>
                            </div>
                        </div>
                    </div>

                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                    (pageChange)="search()"></ngb-pagination>
                    <div class="table-responsive">
                        <table class="table cp-table">
                            <thead>
                                <tr>
                                    <th><span>AUTORIZACIÓN</span></th>
                                    <th><span>NOMBRE, APELLIDOS</span></th>
                                    <th><span>RUT</span></th>
                                    <th><span>CARGO</span></th>
                                    <th><span>OS10</span></th>
                                    <th class="cp-table-hide-mobile"><span>TELEFONO</span></th>
                                    <th class="cp-table-hide-mobile"><span>EMAIL</span></th>
                                    <th class="cp-table-hide-mobile"><span>ULTIMO ACCESO</span></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody *ngIf="items?.length>0">
                                <tr *ngFor="let item of items">
                                    <td style="max-width: 200px;">
                                        <span class="badge"
                                            [ngClass]="item.state_id==1 ? 'bg-primary' : 'bg-danger'">
                                            {{ (item.state_id==1)?'Habilitado':'No habilitado' }}
                                            </span>
                                    </td>
                                    <td>
                                        <span>{{item?.name | uppercase}}</span> &nbsp;
                                        <span>{{item?.lastname | uppercase}}</span>
                                    </td>
                                    <td>
                                        <span>{{item?.rut | uppercase}}</span>
                                    </td>
                                    <td>
                                        <span class="badge" *ngIf="item?.position_name; else noPosition" [style.background]="item.position_color || '#6c757d'">{{ item.position_name | uppercase }}</span>
                                        <ng-template #noPosition><span class="text-muted">—</span></ng-template>
                                    </td>
                                    <td>
                                        <span>{{item?.os10 | uppercase}}</span>
                                    </td>
                                    <td class="cp-table-hide-mobile">
                                        <span>{{item?.phone | uppercase}}</span>
                                    </td>
                                    <td class="cp-table-hide-mobile">
                                        <span>{{item?.email | uppercase}}</span>
                                    </td>
                                    <td class="cp-table-hide-mobile">
                                        <span>{{item?.device_date}}</span>
                                    </td>
                                    <td>
                                        <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                                            <button type="button" class="btn   text-warning"
                                                (click)="openEdit(item,edit)">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                            <button type="button" class="btn  text-danger"
                                                (click)="openDelete(item,remove)">
                                                <i class="fa-solid fa-trash"></i>

                                            </button>
                                        </div>
                                    </td>
                                </tr>                            
                            </tbody>
                            <tbody *ngIf="items?.length==0">
                                <tr>
                                    <td colspan="9" class="fw-lighter text-muted">No se encontraron registros</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                    (pageChange)="search()"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>

</div>
<ng-template #remove let-c="close" let-d="dismiss">

    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Eliminar registro</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>¿Esta seguro que desea eliminar este registro?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">No</button>
        <button type="button" ngbAutofocus class="btn btn-danger" (click)="delete()">Si</button>
    </div>

</ng-template>

<ng-template #add let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-add-guard (success)="get()" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>


<ng-template #edit let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-edit-guard [guard]="selected" (success)="get()" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
<ng-template #addFile let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-upload-file endPoint="1" (onSuccess)="get()" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
<!-- Altas y bajas masivas desde un archivo de RRHH -->
<ng-template #rrhhTpl let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h5 class="modal-title">{{ rrhhTitle }}</h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p class="small text-muted">{{ rrhhHelp }} El RUT es lo que identifica a la persona; el nombre del archivo no importa.</p>
        <input type="file" class="form-control mb-2" accept=".csv,.txt,.xlsx,.xls" (change)="rrhhPick($event)" />
        <div class="text-danger small mb-2" *ngIf="rrhhError">{{ rrhhError }}</div>

        <ng-container *ngIf="rrhhReview as r">
            <div class="alert alert-info small mb-2">
                Archivo reconocido como <strong>{{ r.type === 'workers' ? 'tabla de trabajadores' : (r.type === 'terminations' ? 'finiquitos' : 'lista de RUT') }}</strong>
                con {{ r.total }} fila(s). Revise antes de aplicar: todavía no se cambió nada.
            </div>
            <div class="mb-2">
                <span class="badge bg-light text-dark border me-1 mb-1" *ngFor="let e of rrhhCountEntries()">{{ rrhhActionLabel[e[0]] || e[0] }}: {{ e[1] }}</span>
            </div>
            <div class="table-responsive" style="max-height: 340px; overflow: auto">
                <table class="table table-sm align-middle">
                    <thead><tr><th>RUT</th><th>Nombre</th><th>Resultado</th></tr></thead>
                    <tbody>
                        <tr *ngFor="let i of r.items" [class.table-warning]="i.action === 'invalid_rut' || i.action === 'skipped_terminated'" [class.table-info]="i.action === 'exists'">
                            <td class="text-nowrap">{{ i.rut }}</td>
                            <td>{{ i.guard_name || i.name }}</td>
                            <td><strong>{{ rrhhActionLabel[i.action] || i.action }}</strong><br><small class="text-muted">{{ i.detail }}</small></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="small text-muted mb-1">
                <span class="badge bg-warning-subtle text-dark border me-1">Amarillo</span>RUT inválido o con fecha de término
                <span class="badge bg-info-subtle text-dark border ms-3 me-1">Celeste</span>ya existe en el sistema
            </div>
            <div class="small text-muted" *ngIf="r.total > r.items.length">Se muestran las primeras {{ r.items.length }} filas.</div>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="!rrhhFile || rrhhBusy" (click)="rrhhRun(false)">
            <span class="spinner-border spinner-border-sm me-1" *ngIf="rrhhBusy"></span>Revisar archivo
        </button>
        <button type="button" class="btn" [ngClass]="rrhhKind === 'terminations' ? 'btn-danger' : 'btn-success'" [disabled]="!rrhhReview || rrhhBusy || rrhhPending === 0" (click)="rrhhRun(true)">
            Aplicar ({{ rrhhPending }})
        </button>
    </div>
</ng-template>

<!-- Cargos del personal (etiquetas) -->
<ng-template #positionsTpl let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h5 class="modal-title">Cargos del personal</h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p class="small text-muted">Etiquetas como GGSS, CCTV o Sspp. Se muestran junto al nombre de cada persona en todo el sistema. Al eliminar un cargo deja de mostrarse.</p>
        <div class="input-group mb-3">
            <input class="form-control" [(ngModel)]="posEditing.name" maxlength="60" placeholder="Nombre del cargo (ej.: CCTV)" (keyup.enter)="savePosition()" />
            <input type="color" class="form-control form-control-color" style="max-width: 56px" [(ngModel)]="posEditing.color" title="Color de la etiqueta" />
            <button class="btn btn-primary" type="button" [disabled]="posBusy" (click)="savePosition()">{{ posEditing.id ? 'Guardar' : 'Crear' }}</button>
            <button class="btn btn-outline-secondary" type="button" *ngIf="posEditing.id" (click)="posEditing = { name: '', color: '#6c757d' }">Cancelar</button>
        </div>
        <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let p of positions">
                <span><span class="badge me-2" [style.background]="p.color || '#6c757d'">{{ p.name | uppercase }}</span><small class="text-muted">{{ p.guards }} guardia(s)</small></span>
                <span class="text-nowrap">
                    <button class="btn btn-sm btn-outline-secondary me-1" (click)="editPosition(p)" title="Editar"><i class="fa-solid fa-pen"></i></button>
                    <button class="btn btn-sm btn-outline-danger" (click)="deletePosition(p)" [disabled]="posBusy" title="Eliminar"><i class="fa-solid fa-trash"></i></button>
                </span>
            </li>
            <li class="list-group-item text-muted" *ngIf="!positions.length">Aún no hay cargos. Cree el primero arriba.</li>
        </ul>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cerrar</button>
    </div>
</ng-template>
